import { render, staticRenderFns } from "./ProgressCard.vue?vue&type=template&id=2af5a7d5"
import script from "./ProgressCard.vue?vue&type=script&lang=js"
export * from "./ProgressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports